import axios from "axios";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { PublicClientApplication,InteractionStatus, InteractionType } from "@azure/msal-browser";
import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

let isInteractionInProgress = false;

const tenantId = "c0ca254d-93a5-44df-a85c-818538084df3";
const clientId = "ec8a2980-6334-4a22-a7e2-9ad957eaa282";
const clientSecret = "1eq8Q~XTsYAJQ1QbHOpJna3yS-AMvXKt~leQzaqz";
const redirectUri = "http://localhost:3003/manage-search";



export const MeetingService = {
    getAuthorization,
    createTeamsMeeting,
    addTeamsEvent,
    getTeamsEventByNodeMid,
    getMembersListOfNode
};


// async function getAuthorization() {
//   try {
//     const loginResult = await msalInstance.loginPopup(loginRequest);
    
//     return loginResult?.accessToken;
//   } catch (err) {
//     console.error("Authorization redirect failed:", err);
//     throw err;
//   }
// }

async function getAuthorization(redirectPath) {
  if (isInteractionInProgress) {
    console.warn("Authorization is already in progress.");
    return;
  }

  isInteractionInProgress = true;

  try {

    const msalInstance = new PublicClientApplication({
      auth: {
        clientId,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: redirectPath
      }
    });

    const loginRequest = {
      scopes: ["User.Read", "OnlineMeetings.ReadWrite", "offline_access", "Calendars.ReadWrite"]
    };

    const loginResult = await msalInstance.loginPopup(loginRequest);
    return loginResult?.accessToken;
  } catch (err) {
    console.error("Authorization failed:", err);
    throw err;
  } finally {
    isInteractionInProgress = false;
  }
}

async function createTeamsMeeting(accessToken,payload) {

  const url = "https://graph.microsoft.com/v1.0/me/events";

  // const payload = {
  //   subject: "Test meeting",
  //   body: {
  //     contentType: "HTML",
  //     content: "Does this time work for you?"
  //   },
  //   start: {
  //     dateTime: new Date(Date.now() + 60 * 60000).toISOString(), // Start 60 mins later
  //     timeZone: "Pacific Standard Time"
  //   },
  //   end: {
  //     dateTime: new Date(Date.now() + 70 * 60000).toISOString(), // 60 min duration
  //     timeZone: "Pacific Standard Time"
  //   },
  //   location: {
  //     displayName: "Online"
  //   },
  //   attendees: [
  //     {
  //       emailAddress: {
  //         address: "randikasahan652@gmail.com",
  //         name: "Sahan Randika"
  //       },
  //       type: "required"
  //     }
  //   ],
  //   allowNewTimeProposals: true,
  //   isOnlineMeeting: true,
  //   onlineMeetingProvider: "teamsForBusiness"
  // };

  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Prefer: 'outlook.timezone="Pacific Standard Time"'
      }
    });

    return response.data;
  } catch (err) {
    console.error("Graph API calendar meeting creation failed:", err.response?.data || err.message);
    throw err;
  }
}

async function addTeamsEvent(meetingData) {

  
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(meetingData),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/calendar-events/add-teams-event`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getTeamsEventByNodeMid(node_mid) {

  
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/calendar-events/get-teams-events-by-node-mid?node_mid=${node_mid}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getMembersListOfNode(node_mid, lg_user_id, lg_user_table_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/calendar-events/getAllMembers/${node_mid}/${lg_user_id}/${lg_user_table_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response)
}